import React from 'react';

// Logo variant imports - using app icon plus full logo variants
import iconLogo192 from './linfinity-icon-192.svg';
import iconLogo256 from './linfinity-icon-256.svg';
import fullLogo600 from './linfinity-logo-600.svg';
import fullLogo800 from './linfinity-logo-800.svg';

interface LinfinityLogoProps {
  width?: number | string;
  height?: number | string;
  size?: 'icon' | 'small' | 'medium' | 'large' | 'horizontal';
  className?: string;
  style?: React.CSSProperties;
}

const LinfinityLogo: React.FC<LinfinityLogoProps> = ({
  width,
  height,
  size = 'medium',
  className = '',
  style = {},
  ...props
}) => {
  // Determine which logo variant to use
  let logoSrc: string;
  let defaultWidth: number | string;
  let defaultHeight: number | string;

  switch (size) {
    case 'icon':
      logoSrc = iconLogo192;
      defaultWidth = 48;
      defaultHeight = 48;
      break;
    case 'small':
      logoSrc = iconLogo256;
      defaultWidth = 64;
      defaultHeight = 64;
      break;
    case 'medium':
      logoSrc = fullLogo600;
      defaultWidth = 250;
      defaultHeight = 80; // Maintaining aspect ratio of 600x192
      break;
    case 'large':
      logoSrc = fullLogo800;
      defaultWidth = 350;
      defaultHeight = 112; // Maintaining aspect ratio of 800x256
      break;
    case 'horizontal':
    default:
      logoSrc = fullLogo600;
      defaultWidth = 300;
      defaultHeight = 96; // Maintaining aspect ratio of 600x192
      break;
  }

  // Use custom dimensions if provided, otherwise use defaults
  const finalWidth = width || defaultWidth;
  const finalHeight = height || defaultHeight;

  return (
    <img
      src={logoSrc}
      alt="Linfinity Engineering"
      width={finalWidth}
      height={finalHeight}
      className={className}
      style={{
        objectFit: 'contain',
        ...style
      }}
      {...props}
    />
  );
};

export default LinfinityLogo;
